import React, { useState } from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';
;;
import { Button, Card, Container } from 'src/ui/mui-ui-kit';;
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export function Stepper({ steps, activeStep, onPrevStep, onNextStep }) {
  const [nextEnabled, setNextEnabled] = useState(false);
  const progressWidth = (activeStep / (steps.length - 1)) * 100;
  const CurrentComponent = steps.find((_step, index) => index === activeStep)
    .component;

  return (
    <Container className="stepper">
      <div className="steps">
        <ol>
          {steps.map((step, index) => {
            const itemClassNames = classNames('step-item', {
              'is-active': activeStep === index,
              'is-finished': activeStep > index,
            });
            return (
              <li className={itemClassNames} key={step.label}>
                {step.label}
              </li>
            );
          })}
        </ol>
        <div className="steps-progress-bar">
          <div
            className="steps-progress"
            style={{ width: `${progressWidth}%` }}
          />
        </div>
      </div>
      <Card className="step-content">
        <CurrentComponent setNextEnabled={setNextEnabled} />
      </Card>
      <div className="footer-navigation">
        {activeStep > 0 && (
          <Button
            isColor="text"
            hasTextColor="grey"
            className="previous-btn"
            onClick={onPrevStep}
          >
            <span className="icon is-left">
              <FontAwesomeIcon icon={['fal', 'arrow-left']} />
            </span>
            <span>Previous</span>
          </Button>
        )}
        <span className="spacer" />
        <div className="pages has-text-weight-semibold">
          {activeStep + 1}/{steps.length}
        </div>
        {activeStep < steps.length - 1 && (
          <Button
            isColor="gradient-bright"
            disabled={!nextEnabled}
            onClick={onNextStep}
          >
            <span>Next</span>
            <span className="icon is-right">
              <FontAwesomeIcon icon={['fal', 'arrow-right']} />
            </span>
          </Button>
        )}
      </div>
    </Container>
  );
}

Stepper.propTypes = {
  steps: propTypes.arrayOf(
    propTypes.shape({
      label: propTypes.string.isRequired,
      component: propTypes.oneOfType([propTypes.func, propTypes.object])
        .isRequired,
    })
  ).isRequired,
  activeStep: propTypes.number.isRequired,
  onNextStep: propTypes.func.isRequired,
  onPrevStep: propTypes.func.isRequired,
};
